import React from 'react'

//Bibliotecas
import styled from 'styled-components';

//Imágenes
import { Circle } from 'react-feather';

function Table({ data, ova, ovaSelection, ovas }) {

    //Calcular cantidad de contenido revisado en un ova
    function calcularRevisado(progreso) {
        if (progreso != undefined) {
            let completado = 0;
            progreso.forEach(element => {
                if (typeof element === 'object') {
                    if (element.success == true) {
                        completado++;
                    }
                } else {
                    if (element == true) {
                        completado++;
                    }
                }
            });
            return `${completado}/${progreso.length}`
        }
    }

    //Calcular el porcentaje de ova completado
    function calcularPorcentaje(progreso) {
        if (progreso != undefined) {
            let completado = 0;
            progreso.forEach(element => {
                if (typeof element === 'object') {
                    if (element.success == true) {
                        completado++;
                    }
                } else {
                    if (element == true) {
                        completado++;
                    }
                }
            });
            return Math.round((completado / progreso.length) * 100);
        }
    }

    return (
        <>
            {data.length > 0 &&
                <Tabla>
                    {ovaSelection != 'Global' ? (<>
                        <thead>
                            <tr>
                                <th>Grupo</th>
                                <th>Contenido Revisado</th>
                                {data[0]?.progreso[ova].map((content) => {
                                    if (typeof content == 'object') {
                                        return <th>Actividad</th>
                                    }
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((grupo) => (
                                <tr>
                                    <td>{grupo.estudiantes.map((est) => (<p>{est.nombre}</p>))}</td>
                                    <td>{calcularRevisado(grupo?.progreso[ova])}</td>
                                    {grupo.progreso[ova].map((status) => {
                                        if (typeof status == 'object') {
                                            if (status.success) {
                                                return <td><div className='status'><Circle className='ok'></Circle><span>{status.pistas} pistas</span></div></td>
                                            } else {
                                                return <td><Circle className='not-ok'></Circle></td>
                                            }
                                        }
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </>) :
                        (<>
                            <thead>
                                <tr>
                                    <th>Grupo</th>
                                    {ovas.slice(0, ovas.length - 1).map((ova, index) => <th>OVA {ova.nombre}</th>)}
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((grupo) => (
                                    <tr>
                                        <td>{grupo.estudiantes.map((est) => (<p>{est?.nombre}</p>))}</td>
                                        {ovas.slice(0, ovas.length - 1).map((ova) => {
                                            if(calcularPorcentaje(grupo?.progreso[ova._id])==100){
                                                return <td><div className='status'><Circle className='ok'></Circle><span>{calcularPorcentaje(grupo.progreso[ova._id])}%</span></div></td>
                                            }else{
                                                return <td><div className='status'><Circle className='not-ok'></Circle><span>{calcularPorcentaje(grupo.progreso[ova._id])}%</span></div></td>
                                            }
                                        }
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </>)}

                </Tabla>
            }
            {data.length == 0 &&
                <Message>
                    <span>No se han encontrado resultados</span>
                </Message>
            }
        </>
    )
}

export default Table

const Tabla = styled.table`
    box-sizing:border-box;
    margin-top:32px;
    border-collapse:collapse;
    border-radius:32px;
    display:block;
    height:70vh;
    overflow-y:scroll;

    th,td{
        padding:16px 32px;
    }

    tr{
        border-bottom:2px solid var(--color-gris-claro);
    }

    th{
        font-weight:700;
        color: var(--color-morado-oscuro);
    }

    td{
        .ok{
            width:16px;
            stroke: none;
            fill: #7FFFAA;
        }
        .not-ok{
            width:16px;
            stroke: none;
            fill: #FEBE32;
        }
        svg{
            margin-right:8px;
        }

        .status{
            display:flex;
            align-items:center;
            justify-content:center;
            width:100%;
        }
    
    }

    .status{
        display:flex;
        flex-direction:row;
        justify-content:space-between;
        align-items:center;
        width: 64px;
    }

    
    thead {
        background: var(--color-blanco);
        position: -webkit-sticky; position: sticky; top: 0px; z-index: 1;
    }

    
    tbody{
        width:100%;
        overflow:auto;
    }

  
`;

const Message = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    min-height:200px;
    span{
        color:var(--color-morado-oscuro);
        font-weight:700;
    }
`;

